// TODO TEST MAJOR CHANGES
import messaging from "firebase/messaging";
import firebase from "firebase/app";
import * as log from "loglevel";
import { setFirebaseToken } from "./firebaseWebpushHandler";

export default async (hotelConfig, userPrivileges) => {
  const config = {
    apiKey: "AIzaSyCLCpyppiXURfM4yQJWI6kL5Gvu2J1YQmQ",
    authDomain: "webee-done.firebaseapp.com",
    databaseURL: "https://webee-done.firebaseio.com",
    projectId: "webee-done",
    storageBucket: "webee-done.appspot.com",
    messagingSenderId: "926867265121",
    appId: "1:926867265121:web:e3a68283ed202a38a2fc20",
    measurementId: "G-55TVBQ62ER"
  };

  if (!firebase.apps.length) {
    firebase.initializeApp(config);
  }
  if (firebase.messaging.isSupported()) {
    const fMessaging = firebase.messaging();
    // TODO: requestPermission deprecated to use Notification.requestPermission
    return Notification.requestPermission()
      .then(() => {
        try {
          fMessaging.usePublicVapidKey("BEUKZNp2uTQ9sEfuPYLRucsPVXpktlAFJ4dlekBTHrZYVpiIPXz9iCDiVIwETzhRDRWHvDMYSSNtYKGMfU2zYz8");
        } catch (err) {
          console.error("Error", err);
        }
        // Get Instance ID token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.

        navigator.serviceWorker.ready.then(async registration => {
          await fMessaging.useServiceWorker(registration);
          fMessaging
            .getToken()
            .then(async currentToken => {
              if (currentToken) {
                await setFirebaseToken(currentToken, userPrivileges);
                // updateUIForPushEnabled(currentToken);
              } else {
                // Show permission request.
                log.error("No Instance ID token available. Request permission to generate one.");
                // fMessaging
                //   .deleteToken(currentToken)
                //   .then(async token => {
                //     await setFirebaseToken(currentToken, userPrivileges);
                //     return;
                //   })
                //   .catch(err => {
                //     console.error('An error occurred while deleteing token', err);
                //     // showToken('Error retrieving Instance ID token. ', err);
                //     // setTokenSentToServer(false);
                //   });
                throw new Error("Push permission required");
                // fMessaging.deleteToken(currentToken).then(async token => {
                //   fMessaging.getToken().then(async newToken => {
                //     await setFirebaseToken(newToken, userPrivileges);
                //   });
                // });
                // Show permission UI.
                // updateUIForPushPermissionRequired();
                // setTokenSentToServer(false);
              }
            })
            .catch(err => {
              log.error("An error occurred while retrieving token", err);
              throw Error("An error occurred while retrieving token");
              // showToken('Error retrieving Instance ID token. ', err);
              // setTokenSentToServer(false);
            });
          // Callback fired if Instance ID token is updated.
          fMessaging.onTokenRefresh(() => {
            fMessaging
              .getToken()
              .then(async refreshedToken => {
                // Indicate that the new Instance ID token has not yet been sent to the
                // app server.
                // setTokenSentToServer(false);
                // Send Instance ID token to app server.
                await setFirebaseToken(refreshedToken, userPrivileges);
                // ...
              })
              .catch(err => {
                log.error("Unable to retrieve refreshed token", err);
                throw new Error("Push permission required");
                // showToken('Unable to retrieve refreshed token ', err);
              });
          });
        });
      })
      .catch(err => {
        log.error("Permission not allowed", err);
        // throw Error('An error occurred while retrieving token');
        // showToken('Error retrieving Instance ID token. ', err);
        // setTokenSentToServer(false);
      });
  }

  //   return fMessaging
  //     .requestPermission()
  //     .then(() => {
  //       // Get Instance ID token. Initially this makes a network call, once retrieved
  //       // subsequent calls to getToken will return from cache.
  //       fMessaging
  //         .getToken()
  //         .then(async currentToken => {
  //           if (currentToken) {
  //             await setFirebaseToken(currentToken, userPrivileges);
  //             // updateUIForPushEnabled(currentToken);
  //           } else {
  //             // Show permission request.
  //             log.error('No Instance ID token available. Request permission to generate one.');

  //             throw new Error('Push permission required');
  //             // Show permission UI.
  //             // updateUIForPushPermissionRequired();
  //             // setTokenSentToServer(false);
  //           }
  //         })
  //         .catch(err => {
  //           log.error('An error occurred while retrieving token', err);
  //           throw Error('An error occurred while retrieving token');
  //           // showToken('Error retrieving Instance ID token. ', err);
  //           // setTokenSentToServer(false);
  //         });
  //       // Callback fired if Instance ID token is updated.
  //       fMessaging.onTokenRefresh(() => {
  //         fMessaging
  //           .getToken()
  //           .then(async refreshedToken => {
  //             // Indicate that the new Instance ID token has not yet been sent to the
  //             // app server.
  //             // setTokenSentToServer(false);
  //             // Send Instance ID token to app server.
  //             await setFirebaseToken(refreshedToken, userPrivileges);
  //             // ...
  //           })
  //           .catch(err => {
  //             log.error('Unable to retrieve refreshed token', err);
  //             throw new Error('Push permission required');
  //             // showToken('Unable to retrieve refreshed token ', err);
  //           });
  //       });

  //       return fMessaging;
  //     })
  //     .catch(err => {
  //       log.error('Unable to get permission to notify', err);
  //       throw Error('Unable to get permission to notify');
  //     });
};
